import { Paths } from '../../lib/constants/path'
import { RoleEnum } from '../../lib/types/enums/users/role.enum'
import { Route } from '../../lib/types/routes'
import PaymentConditionCreatePage from './payment-condition-create'
import PaymentConditionListPage from './payment-condition-list'
import PaymentConditionUpdatePage from './payment-condition-update'

const paymentConditionRoutes: Route[] = [
  {
    path: Paths.PAYMENT_CONDITIONS_CREATE_PAGE,
    element: <PaymentConditionCreatePage />,
    roles: [RoleEnum.ADMIN]
  },
  {
    path: Paths.PAYMENT_CONDITIONS_LIST_PAGE,
    element: <PaymentConditionListPage />,
    roles: [RoleEnum.ADMIN]
  },
  {
    path: Paths.PAYMENT_CONDITIONS_UPDATE_PAGE,
    element: <PaymentConditionUpdatePage />,
    roles: [RoleEnum.ADMIN]
  }
]

export default paymentConditionRoutes
